import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=52d91a25&scoped=true"
import script from "./side-nav.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-nav.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=52d91a25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d91a25",
  null
  
)

export default component.exports